(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 87357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Box_Box; }
});

// EXTERNAL MODULE: ./node_modules/@mui/system/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(54695);
// EXTERNAL MODULE: ./node_modules/@mui/system/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(60916);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/index.js + 8 modules
var styled_engine = __webpack_require__(24943);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx_styleFunctionSx = __webpack_require__(86523);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js
var extendSxProp = __webpack_require__(39707);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useTheme.js + 1 modules
var useTheme = __webpack_require__(79718);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createBox.js


const _excluded = ["className", "component"];






function createBox(options = {}) {
  const {
    defaultTheme,
    defaultClassName = 'MuiBox-root',
    generateClassName,
    styleFunctionSx = styleFunctionSx_styleFunctionSx/* default */.Z
  } = options;
  const BoxRoot = (0,styled_engine/* default */.ZP)('div')(styleFunctionSx);
  const Box = /*#__PURE__*/react.forwardRef(function Box(inProps, ref) {
    const theme = (0,useTheme/* default */.Z)(defaultTheme);

    const _extendSxProp = (0,extendSxProp/* default */.Z)(inProps),
          {
      className,
      component = 'div'
    } = _extendSxProp,
          other = (0,objectWithoutPropertiesLoose/* default */.Z)(_extendSxProp, _excluded);

    return /*#__PURE__*/(0,jsx_runtime.jsx)(BoxRoot, (0,esm_extends/* default */.Z)({
      as: component,
      ref: ref,
      className: (0,clsx_m/* default */.Z)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: theme
    }, other));
  });
  return Box;
}
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
var ClassNameGenerator = __webpack_require__(37078);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 14 modules
var createTheme = __webpack_require__(21265);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Box/Box.js




const defaultTheme = (0,createTheme/* default */.Z)();
const Box = createBox({
  defaultTheme,
  defaultClassName: 'MuiBox-root',
  generateClassName: ClassNameGenerator/* default.generate */.Z.generate
});
 false ? 0 : void 0;
/* harmony default export */ var Box_Box = (Box);

/***/ }),

/***/ 64722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InputAdornment_InputAdornment; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1048);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/extendSxProp.js
var extendSxProp = __webpack_require__(39707);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 3 modules
var useThemeProps = __webpack_require__(54502);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Typography/typographyClasses.js

function getTypographyUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiTypography', slot);
}
const typographyClasses = (0,generateUtilityClasses/* default */.Z)('MuiTypography', ['root', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'inherit', 'button', 'caption', 'overline', 'alignLeft', 'alignRight', 'alignCenter', 'alignJustify', 'noWrap', 'gutterBottom', 'paragraph']);
/* harmony default export */ var Typography_typographyClasses = ((/* unused pure expression or super */ null && (typographyClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/Typography/Typography.js


const _excluded = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"];











const useUtilityClasses = ownerState => {
  const {
    align,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, ownerState.align !== 'inherit' && `align${(0,capitalize/* default */.Z)(align)}`, gutterBottom && 'gutterBottom', noWrap && 'noWrap', paragraph && 'paragraph']
  };
  return (0,composeClasses/* default */.Z)(slots, getTypographyUtilityClass, classes);
};

const TypographyRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiTypography',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.variant && styles[ownerState.variant], ownerState.align !== 'inherit' && styles[`align${(0,capitalize/* default */.Z)(ownerState.align)}`], ownerState.noWrap && styles.noWrap, ownerState.gutterBottom && styles.gutterBottom, ownerState.paragraph && styles.paragraph];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  margin: 0
}, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
  textAlign: ownerState.align
}, ownerState.noWrap && {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}, ownerState.gutterBottom && {
  marginBottom: '0.35em'
}, ownerState.paragraph && {
  marginBottom: 16
}));
const defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
  inherit: 'p'
}; // TODO v6: deprecate these color values in v5.x and remove the transformation in v6

const colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};

const transformDeprecatedColors = color => {
  return colorTransformations[color] || color;
};

const Typography = /*#__PURE__*/react.forwardRef(function Typography(inProps, ref) {
  const themeProps = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiTypography'
  });
  const color = transformDeprecatedColors(themeProps.color);
  const props = (0,extendSxProp/* default */.Z)((0,esm_extends/* default */.Z)({}, themeProps, {
    color
  }));

  const {
    align = 'inherit',
    className,
    component,
    gutterBottom = false,
    noWrap = false,
    paragraph = false,
    variant = 'body1',
    variantMapping = defaultVariantMapping
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    align,
    color,
    className,
    component,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    variantMapping
  });

  const Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TypographyRoot, (0,esm_extends/* default */.Z)({
    as: Component,
    ref: ref,
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(classes.root, className)
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Typography_Typography = (Typography);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControlContext.js
var FormControlContext = __webpack_require__(47167);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/useFormControl.js
var useFormControl = __webpack_require__(74423);
;// CONCATENATED MODULE: ./node_modules/@mui/material/InputAdornment/inputAdornmentClasses.js

function getInputAdornmentUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiInputAdornment', slot);
}
const inputAdornmentClasses = (0,generateUtilityClasses/* default */.Z)('MuiInputAdornment', ['root', 'filled', 'standard', 'outlined', 'positionStart', 'positionEnd', 'disablePointerEvents', 'hiddenLabel', 'sizeSmall']);
/* harmony default export */ var InputAdornment_inputAdornmentClasses = (inputAdornmentClasses);
;// CONCATENATED MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js



var _span;

const InputAdornment_excluded = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"];














const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, styles[`position${(0,capitalize/* default */.Z)(ownerState.position)}`], ownerState.disablePointerEvents === true && styles.disablePointerEvents, styles[ownerState.variant]];
};

const InputAdornment_useUtilityClasses = ownerState => {
  const {
    classes,
    disablePointerEvents,
    hiddenLabel,
    position,
    size,
    variant
  } = ownerState;
  const slots = {
    root: ['root', disablePointerEvents && 'disablePointerEvents', position && `position${(0,capitalize/* default */.Z)(position)}`, variant, hiddenLabel && 'hiddenLabel', size && `size${(0,capitalize/* default */.Z)(size)}`]
  };
  return (0,composeClasses/* default */.Z)(slots, getInputAdornmentUtilityClass, classes);
};

const InputAdornmentRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiInputAdornment',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  display: 'flex',
  height: '0.01em',
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: '2em',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  color: (theme.vars || theme).palette.action.active
}, ownerState.variant === 'filled' && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${InputAdornment_inputAdornmentClasses.positionStart}&:not(.${InputAdornment_inputAdornmentClasses.hiddenLabel})`]: {
    marginTop: 16
  }
}, ownerState.position === 'start' && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, ownerState.position === 'end' && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, ownerState.disablePointerEvents === true && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: 'none'
}));
const InputAdornment = /*#__PURE__*/react.forwardRef(function InputAdornment(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiInputAdornment'
  });

  const {
    children,
    className,
    component = 'div',
    disablePointerEvents = false,
    disableTypography = false,
    position,
    variant: variantProp
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, InputAdornment_excluded);

  const muiFormControl = (0,useFormControl/* default */.Z)() || {};
  let variant = variantProp;

  if (variantProp && muiFormControl.variant) {
    if (false) {}
  }

  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    hiddenLabel: muiFormControl.hiddenLabel,
    size: muiFormControl.size,
    disablePointerEvents,
    position,
    variant
  });

  const classes = InputAdornment_useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormControlContext/* default.Provider */.Z.Provider, {
    value: null,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InputAdornmentRoot, (0,esm_extends/* default */.Z)({
      as: component,
      ownerState: ownerState,
      className: (0,clsx_m/* default */.Z)(classes.root, className),
      ref: ref
    }, other, {
      children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/(0,jsx_runtime.jsx)(Typography_Typography, {
        color: "text.secondary",
        children: children
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [position === 'start' ?
        /* notranslate needed while Google Translate will not fix zero-width space issue */
        _span || (_span = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "notranslate",
          children: "\u200B"
        })) : null, children]
      })
    }))
  });
});
 false ? 0 : void 0;
/* harmony default export */ var InputAdornment_InputAdornment = (InputAdornment);

/***/ }),

/***/ 39707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ extendSxProp; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54695);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60916);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59766);
/* harmony import */ var _getThemeValue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85578);


const _excluded = ["sx"];



const splitProps = props => {
  const result = {
    systemProps: {},
    otherProps: {}
  };
  Object.keys(props).forEach(prop => {
    if (_getThemeValue__WEBPACK_IMPORTED_MODULE_0__/* .propToStyleFunction */ .Gc[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};

function extendSxProp(props) {
  const {
    sx: inSx
  } = props,
        other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, _excluded);

  const {
    systemProps,
    otherProps
  } = splitProps(other);
  let finalSx;

  if (Array.isArray(inSx)) {
    finalSx = [systemProps, ...inSx];
  } else if (typeof inSx === 'function') {
    finalSx = (...args) => {
      const result = inSx(...args);

      if (!(0,_mui_utils__WEBPACK_IMPORTED_MODULE_2__/* .isPlainObject */ .P)(result)) {
        return systemProps;
      }

      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, systemProps, result);
    };
  } else {
    finalSx = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, systemProps, inSx);
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, otherProps, {
    sx: finalSx
  });
}

/***/ }),

/***/ 95056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDeviceDetect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useDeviceDetect() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isMobile = _useState[0],
      setMobile = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      isAndroid = _useState2[0],
      setIsAndroid = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      isIos = _useState3[0],
      setIsIos = _useState3[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
    var mobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));
    var android = Boolean(userAgent.match(/android/i));
    var ios = Boolean(userAgent.match(/iPad|iPhone|iPod/i)) && !window.MSStream;
    setMobile(mobile);
    setIsAndroid(android);
    setIsIos(ios);
  }, []);
  return {
    isMobile: isMobile,
    isAndroid: isAndroid,
    isIos: isIos
  };
}

/***/ }),

/***/ 69976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Login; }
/* harmony export */ });
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(87357);
/* harmony import */ var _mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(64722);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(72255);
/* harmony import */ var _mui_material_TextField__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_icons_bi__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(47516);
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(79352);
/* harmony import */ var _api_wave_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87517);
/* harmony import */ var _components_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3805);
/* harmony import */ var _components_CustomHead__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19148);
/* harmony import */ var _components_MainLogo_MainLogo__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10625);
/* harmony import */ var _components_OTPView_OTPView__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91320);
/* harmony import */ var _hooks_useDeviceDetect__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95056);
/* harmony import */ var _store_guestUser__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42604);
/* harmony import */ var _store_loader__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(58766);
/* harmony import */ var _store_user__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73471);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(99700);
/* harmony import */ var _utils_themeProvider__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(65168);
/* harmony import */ var _utils_verifications__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(15471);
/* harmony import */ var _login_module_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(302);
/* harmony import */ var _login_module_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_login_module_scss__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(85893);



























var DEFAULT_ERROR_MESSAGE = 'Κάτι πήγε στραβά. Παρακαλώ προσπαθήστε ξανά.';
var PAGE_CONFIG = {
  digital: {
    headerText: 'Συνδέσου στο λογαριασμό σου',
    inputText: 'Αριθμός Κάρτας',
    mainText: 'Συνδέσου τώρα εισάγοντας τον αριθμό της κάρτας σου, για να σου στείλουμε με SMS τον κωδικό επιβεβαίωσης.',
    hasSeparator: false,
    hasLoginLink: true,
    regexPattern: "^9618(\\d{8}|\\d{9})$",
    regexErrorMessage: 'O αριθμός κάρτας είναι λάθος.',
    otpMethod: 'login-digital'
  },
  notDigital: {
    headerText: 'Σύνδεση στον λογαριασμό σου',
    inputText: 'Κινητό τηλέφωνο ή αριθμός κάρτας',
    mainText: 'Συνδέσου τώρα εισάγοντας τον αριθμό κινητού σου ή την κάρτα σου, για να σου στείλουμε με SMS τον κωδικό επιβεβαίωσης.',
    hasSeparator: true,
    hasLoginLink: false,
    regexPattern: '^(69\\d{8}|\\d{12,13})$',
    regexErrorMessage: 'Το κινητό τηλέφωνο ή ο αριθμός κάρτας είναι λάθος.',
    otpMethod: 'login'
  }
};
var QRScannerLoginWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7430), __webpack_require__.e(5512), __webpack_require__.e(1591)]).then(__webpack_require__.bind(__webpack_require__, 1591));
}, {
  suspense: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1591)];
    }
  }
});
function Login() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(''),
      id = _useState[0],
      setId = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(''),
      mobileNumber = _useState2[0],
      setMobileNumber = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      phoneError = _useState3[0],
      setPhoneError = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(' '),
      errorMsg = _useState4[0],
      setErrorMsg = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)('login'),
      step = _useState5[0],
      setStep = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(PAGE_CONFIG.notDigital),
      configuration = _useState6[0],
      setConfiguration = _useState6[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      isDigital = _useState7[0],
      setIsDigital = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false),
      openScanner = _useState8[0],
      setOpenScanner = _useState8[1];

  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
    var _router$query;

    if (router.isReady && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.isDigital) {
      if (router.query.isDigital === 'digital') {
        setIsDigital(true);
      }
    }
  }, [router.query.isDigital]);
  (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function () {
    if (isDigital) {
      setConfiguration(PAGE_CONFIG[router.query.isDigital]);
    }
  }, [isDigital]);

  function onClickLogin() {
    setConfiguration(PAGE_CONFIG.notDigital);
    setIsDigital(!isDigital);
    setMobileNumber('');
    setPhoneError(false);
    setErrorMsg('');
    router.push({
      pathname: router.asPath.split('?')[0]
    }, undefined, {
      shallow: true
    });
  }

  var _useDeviceDetect = (0,_hooks_useDeviceDetect__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(),
      isMobile = _useDeviceDetect.isMobile;

  function successRedirect() {
    router.push('/digital-card-success/?origin=login', '/digital-card-success/?origin=login');
  }

  function onSubmitPhone(e) {
    e.preventDefault();
    setPhoneError(false);
    setErrorMsg(configuration.regexErrorMessage);

    if (_store_guestUser__WEBPACK_IMPORTED_MODULE_11__/* ["default"].getValue */ .Z.getValue()) {
      _store_guestUser__WEBPACK_IMPORTED_MODULE_11__/* ["default"].setInitUser */ .Z.setInitUser();
    }

    if (!id) {
      setPhoneError(true);
    }

    (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_14__/* .addToAnalyticsGenericEvent */ .RY)('login');
    requestOTP();
  }

  function onBlurPhone(loginId) {
    var numberIdNoSpace = loginId.replace(/\s/g, '');
    var parsePattern = new RegExp(configuration.regexPattern);
    var isValid = numberIdNoSpace.match(parsePattern);

    if (!isValid) {
      setPhoneError(true);
      setErrorMsg(configuration.regexErrorMessage);
    } else {
      setPhoneError(false);
      setErrorMsg('');
    }
  }

  function requestOTP() {
    var numberIdNoSpace = id.replace(/\s/g, '');
    var isValid = numberIdNoSpace.match(configuration.regexPattern);

    if (!isValid) {
      setPhoneError(true);
      setErrorMsg(configuration.regexErrorMessage);
      return;
    }

    _store_loader__WEBPACK_IMPORTED_MODULE_12__/* ["default"].addEvent */ .Z.addEvent('LOGIN');
    var verificationMethod = _utils_verifications__WEBPACK_IMPORTED_MODULE_16__/* ["default"].isCardNumber */ .ZP.isCardNumber(numberIdNoSpace) ? 'card' : 'mobile';
    _api_wave_auth__WEBPACK_IMPORTED_MODULE_5__/* ["default"].loginSendOTP */ .ZP.loginSendOTP(numberIdNoSpace, verificationMethod).then(function (response) {
      _store_user__WEBPACK_IMPORTED_MODULE_13__/* ["default"].update */ .Z.update({
        maskedMobile: response.payload.verification.mobile
      });
      setMobileNumber(response.payload.verification.verificationToken);
      setStep('otp');
      setPhoneError(false);
      setErrorMsg(' ');
    }).catch(function (error) {
      var errorMessage = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(error, 'response.data.error.userMessage', DEFAULT_ERROR_MESSAGE);
      var errorCode = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(error, 'response.data.error.code');

      if (errorCode === 'USRINT063') {
        _store_user__WEBPACK_IMPORTED_MODULE_13__/* ["default"].update */ .Z.update({
          cardId: numberIdNoSpace
        });

        if (isDigital) {
          router.push('/digital-card-renew', '/digital-card-renew');
          return;
        }

        router.push('/register', '/register');
        return;
      }

      _store_user__WEBPACK_IMPORTED_MODULE_13__/* ["default"].update */ .Z.update({
        cardId: ''
      });
      setPhoneError(true);
      setErrorMsg(errorMessage);
    }).finally(function () {
      _store_loader__WEBPACK_IMPORTED_MODULE_12__/* ["default"].removeEvent */ .Z.removeEvent('LOGIN');
    });
  }

  function onChangePhone(e) {
    var newValue = e.target.value.replace(/[^\d\s]/, '');
    setId(newValue);
  }

  function onOpenScanner() {
    setOpenScanner(true);
  }

  function onScanSuccess(data) {
    var object = JSON.parse(data);
    var newId = JSON.stringify(object);
    setId(newId);
    setOpenScanner(false);
    onBlurPhone(newId);
  }

  function onScanClose() {
    setOpenScanner(false);
  }

  var hasIcons = phoneError || isMobile && isDigital;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("section", {
    className: (_login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().container),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_components_CustomHead__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      title: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7/ \u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("div", {
      className: (_login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().logoContainer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("a", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_components_MainLogo_MainLogo__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("h1", {
      className: (_login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().header),
      children: [configuration.headerText, " "]
    }), step === 'login' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("div", {
        className: (_login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().imageContainer),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("img", {
          className: (_login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().img),
          width: "200",
          height: "200",
          src: "/assets/".concat("kritikos", "/").concat("kritikos", "-login.png"),
          alt: "grocery app"
        })
      }), step === 'login' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("p", {
        className: (_login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().p),
        children: configuration.mainText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("form", {
        noValidate: true,
        className: (_login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().fullWidth),
        onSubmit: onSubmitPhone,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
          sx: phoneError ? {
            height: 'auto',
            minHeight: '5.5rem'
          } : {
            height: '5.5rem'
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_mui_material_styles__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
            theme: _utils_themeProvider__WEBPACK_IMPORTED_MODULE_15__/* .theme */ .r,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
              label: configuration.inputText,
              name: "phone",
              variant: "outlined",
              onChange: onChangePhone,
              onBlur: function onBlur() {
                return onBlurPhone(id);
              },
              fullWidth: true,
              required: true,
              error: phoneError,
              value: id,
              helperText: errorMsg,
              "data-cy": "userId",
              InputProps: {
                endAdornment: hasIcons && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.Fragment, {
                  children: [phoneError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                    position: "end",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_23__/* .RiErrorWarningFill */ .oji, {
                      className: (_login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().waringIcon)
                    })
                  }), isMobile && isDigital && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_mui_material_InputAdornment__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                    position: "end",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_24__/* .BiBarcodeReader */ .OPD, {
                      className: (_login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().barCodeIcon),
                      title: "barCodeClick",
                      onClick: onOpenScanner
                    })
                  })]
                })
              } // eslint-disable-next-line react/jsx-no-duplicate-props
              ,
              inputProps: {
                inputMode: 'numeric',
                pattern: '[0-9]*'
              }
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("div", {
          className: (_login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().primaryButtonContainer),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_components_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_6__/* .PrimaryButton */ .KM, {
            type: "submit",
            "data-cy": "request-otp",
            style: {
              width: '100%'
            },
            disabled: !id || phoneError,
            children: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1"
          })
        })]
      }), configuration.hasSeparator && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("div", {
        className: (_login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().orTextContainer),
        children:  false ? /*#__PURE__*/0 : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("p", {
          className: (_login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().orTextWithLines),
          children: "\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03BA\u03C4\u03B9\u03BA\u03AC \u03BA\u03AC\u03BD\u03B5 \u03B5\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE \u03C3\u03B5 1 \u03BB\u03B5\u03C0\u03C4\u03CC!"
        })
      }), configuration.hasLoginLink ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsxs)("a", {
        className: (_login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().registerLink),
        "data-cy": "login-digital",
        onClick: function onClick() {
          return onClickLogin();
        },
        children: ["\u0388\u03C7\u03C9 \u03AE\u03B4\u03B7 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03C4\u03B1 Supermarket ", "ΚΡΗΤΙΚΟΣ"]
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/register",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("a", {
          className: (_login_module_scss__WEBPACK_IMPORTED_MODULE_18___default().fullWidth),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_components_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_6__/* .SecondaryButton */ .kq, {
            onClick: function onClick() {},
            "data-cy": "register",
            style: {
              width: '100%',
              marginBottom: '1rem'
            },
            children: "\u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE"
          })
        })
      }),  false && /*#__PURE__*/0]
    }), step === 'otp' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(_components_OTPView_OTPView__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      userId: mobileNumber,
      method: configuration.otpMethod,
      successCallback: successRedirect
    }), openScanner && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(react__WEBPACK_IMPORTED_MODULE_4__.Suspense, {
      fallback: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)("p", {}),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__.jsx)(QRScannerLoginWrapper, {
        qrCodeSuccessCallback: onScanSuccess,
        onClose: onScanClose
      })
    })]
  });
}

/***/ }),

/***/ 10545:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(69976);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 302:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"login_container__HyLMG","logoContainer":"login_logoContainer__4y5Fi","header":"login_header__z5vZo","imageContainer":"login_imageContainer__pciAP","img":"login_img__Bmsj1","p":"login_p__QxgAL","fullWidth":"login_fullWidth__HaCcb","primaryButtonContainer":"login_primaryButtonContainer__I80R_","orTextContainer":"login_orTextContainer__2BcWy","orTextGeneric":"login_orTextGeneric__zY13P","orTextWithLines":"login_orTextWithLines__Atd_j","orText":"login_orText__La5fn","waringIcon":"login_waringIcon___BtiN","registerLink":"login_registerLink__IpYVl","barCodeIcon":"login_barCodeIcon__gwrTz"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,3874,3996,9979,1379,4032,9774,2888,179], function() { return __webpack_exec__(10545); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);